import React from 'react';
import { Modal } from 'antd';
import { Icon } from 'ensightful-koala-ui';
import styled from 'styled-components';

import { Subtitle3, Body2 } from 'components/atoms/Text';
import { TextButton } from 'components/molecules/Button';

const StyledModal = styled(Modal)`
    & .ant-modal-content {
        border-radius: 12px;
    }

    & .ant-modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    & .ant-modal-footer {
        display: none;
    }
`;

const StyledIcon = styled(Icon)`
    width: 24px;
    height: 24px;
`;

const Title = styled(Subtitle3)`
    margin: 8px 0 10px;
    color: ${(props) => (props.destructive ? '#b23414' : '#6347ff')};
    text-align: center;
`;

const Content = styled(Body2)`
    max-width: 100%;
    color: #212121;
    text-align: center;
`;

const ButtonContainer = styled.div`
    margin-top: 16px;

    & > button + button {
        margin-left: 32px;
    }
`;

const CancelButton = styled(TextButton)`
    height: fit-content;
    padding: 8px 16px;
    color: #616161;
    border: 1px solid transparent;
    border-radius: 6px;
`;

const ConfirmButton = styled(TextButton)`
    height: fit-content;
    padding: 8px 16px;
    color: ${(props) => (props.destructive ? '#b23414' : '#6347ff')};
    border: 1px solid ${(props) => (props.destructive ? '#b23414' : '#6347ff')};
    border-radius: 6px;

    &:hover {
        background-color: ${(props) => (props.destructive ? '#b23414' : '#6347ff')};
        color: white;
    }
`;

const ConfirmationModal = ({
    visible,
    destructive = true,
    title = '',
    content = '',
    confirmText = 'Delete',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    ...props
}) => {
    return (
        <StyledModal visible={visible} closable={false} width={280} zIndex={1200} {...props}>
            <StyledIcon kind={'warning'} fill={destructive ? '#b23414' : '#6347ff'} />
            <Title destructive={destructive}>{title}</Title>
            <Content>{content}</Content>
            <ButtonContainer>
                <CancelButton onClick={onCancel}>{cancelText}</CancelButton>
                <ConfirmButton destructive={destructive} onClick={onConfirm}>
                    {confirmText}
                </ConfirmButton>
            </ButtonContainer>
        </StyledModal>
    );
};

export default ConfirmationModal;
